import { faTimes } from "@jewlr/pro-regular-svg-icons/faTimes"
import PropTypes from "prop-types"
import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"

import { ItemAction, LineItemCard } from "areas/cart/components"
import { removeLineItem } from "areas/cart/store/actions"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { IS_JEWLR, jewlr_t } from "helpers/application"
import { getImgSrcSet } from "helpers/image"

import Addon from "./addon"
import {
  CardProductImage,
  CardProductImageContainer,
  RemoveItem,
  OutOfStockLabel,
} from "./components"
import GiftOptions from "./gift-wrap/gift-options"
import LineItemDetails from "./line-item-details"
import LineItemInfo from "./line-item-info"
import WarrantyAddon from "./warranty/warranty-addon"

const LineItem = ({ item, setOnRemoveAction }) => {
  const outOfStock = !item.in_stock
  const dispatch = useDispatch()

  const handleRemoveClick = useCallback(() => {
    if (item) {
      setOnRemoveAction(
        () => () => dispatch(removeLineItem(item.id, "product"))
      )
    }
  }, [dispatch, item, setOnRemoveAction])

  return (
    <LineItemCard
      data-ge-basket-cartitemid={`${item.style_code}-${item.sku}`}
      isProduct
    >
      <div className="desktop:gap-24 relative flex gap-16">
        <CardProductImageContainer outOfStock={outOfStock}>
          <CardProductImage
            alt=""
            data-cy={`cart-line-item-img-${item.style_code}`}
            data-sku={item.sku}
            fallback={item.image_url}
            sizes="(min-width: 1024px) 130px, 120px"
            srcSet={getImgSrcSet(item.image_url, 512, {
              dim_key: "dim",
              sizes: [130, 260],
            })}
            title={item.title}
          />
          {outOfStock && <OutOfStockLabel>Out Of Stock</OutOfStockLabel>}
        </CardProductImageContainer>
        <LineItemInfo item={item} />
        <RemoveItem
          aria-label={`Remove ${item.title} from ${jewlr_t("Cart")}`}
          data-cy={`cart-remove-btn-${item.style_code}`}
          onClick={handleRemoveClick}
        >
          <FontAwesomeIcon icon={faTimes} />
        </RemoveItem>
      </div>

      {!outOfStock && (
        <>
          <div className="mb-24 mt-8 flex items-start justify-between">
            <LineItemDetails item={item} />
            <ItemAction asChild>
              <Link
                data-cy={`cart-modify-btn-${item.style_code}`}
                data-lc="line-item-info"
                to={item.modify_url}
              >
                Modify Item
              </Link>
            </ItemAction>
          </div>
          {IS_JEWLR() && (
            <>
              <Addon item={item} setOnRemoveAction={setOnRemoveAction} />
              {!item.reject_addons && <GiftOptions item={item} />}
              {!item.reject_addons && sl.config.enable_extend_warranty && (
                <WarrantyAddon item={item} />
              )}
            </>
          )}
        </>
      )}
    </LineItemCard>
  )
}

LineItem.propTypes = {
  item: PropTypes.object,
  setOnRemoveAction: PropTypes.func,
}

export default LineItem
